import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationFormat',
})
export class DurationFormatPipe implements PipeTransform {
  transform(value: number, valueType: 'minutes' | 'hours' | 'days' = 'minutes'): string {
    if (value == null) return '00:00';
    if (valueType === 'days') return `${value}`;
    const totalHours = valueType === 'hours' ? Math.floor(value) : Math.floor(value / 60);
    const mins = valueType === 'hours' ? Math.round((value % 1) * 60) : Math.round(value % 60);
    return `${String(totalHours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
  }
}
